import { render, staticRenderFns } from "./About.vue?vue&type=template&id=b800825e&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=b800825e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_oo5wulyvj3zulgczlh6g6gwe5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b800825e",
  null
  
)

export default component.exports